<div #root [ngStyle]="style">
  <ng-content></ng-content>
  <div #anchor></div>
</div>
